export interface SectionState {
    state: SectionLoadState;
    numItems?: number;
}

export enum SectionLoadState {
    Unknown,
    Disabled,
    Loading,
    Displayed,
    Failed
}
